import { AbstractControl, ValidatorFn } from "@angular/forms";

export function numarCIValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const regex = /^\d{6,7}$/;

        if (value && !regex.test(value)) {
            return { invalidNumarCI: true };
        }

        return null;
    };
}